export * from './components/Icon/index';
//# sourceMappingURL=Icon.js.map